import React from 'react';
import { Snackbar, Alert, AlertProps, Slide, SlideProps } from '@mui/material';
import { useApp } from '../../contexts/AppContext';

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="left" />;
}

export function ToastContainer() {
  const { toasts, hideToast } = useApp();

  const handleClose = (id: string) => {
    hideToast(id);
  };

  const getSeverity = (type: string): AlertProps['severity'] => {
    switch (type) {
      case 'success':
        return 'success';
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  };

  return (
    <>
      {toasts.map((toast, index) => (
        <Snackbar
          key={toast.id}
          open={true}
          autoHideDuration={toast.duration}
          onClose={() => handleClose(toast.id)}
          TransitionComponent={SlideTransition}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            top: `${88 + index * 80}px !important`, // Stack toasts
          }}
        >
          <Alert
            onClose={() => handleClose(toast.id)}
            severity={getSeverity(toast.type)}
            variant="filled"
            sx={{
              width: '100%',
              minWidth: 300,
              boxShadow: 3,
            }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
} 